

















import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import TaxCertificateList from '@tax-certificates/components/tax-certificate-list.vue';

@Component({
  name: 'bc-activity-tax-certificates',
  components: {
    TaxCertificateList,
    'bpc-content-wrapper': ContentWrapper,
  },
})
export default class ActivityTaxCertificates extends Vue {
  // PROPS
  // DATA
  // LIFECYCLE
  // created(){}
  // mounted(){}
  // updated(){}
  // destroyed(){}
  // COMPUTED
  get actionsPortalTarget() {
    return `activity-tax-certificate-actions-${this.$bpcHelper.generateUUIDv4()}`;
  }
  // METHODS
  // WATCHERS
}
